import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, PLATFORM_ID, Inject, ViewChild, ElementRef, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { DoctorProfileService } from './doctor-profile.service';
import { MatDialog } from '@angular/material/dialog';
import { ShowServicesDialogComponent } from './components/show-services-dialog/show-services-dialog.component';
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { getLinkPreview } from "link-preview-js";
import { FeedOptionsDialogComponent } from 'src/app/doctor/doctor-social/feed-options-dialog/feed-options-dialog.component';
import { OthersFeedOptionsDialogComponent } from 'src/app/doctor/doctor-social/others-feed-options-dialog/others-feed-options-dialog.component';
import { PostDetailsPopUpComponent } from 'src/app/doctor/doctor-social/post-details-pop-up/post-details-pop-up.component';
import { ToastrService } from 'ngx-toastr';
import { InsightsDialogComponent } from 'src/app/doctor/doctor-social/insights-dialog/insights-dialog.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { LikesListDialogComponent } from 'src/app/doctor/doctor-social/likes-list-dialog/likes-list-dialog.component';
import { OptionsForModComponent } from 'src/app/doctor/doctor-social/options-for-mod/options-for-mod.component';
import { DoctorSocialService } from 'src/app/doctor/doctor-social/doctor-social.service';
import { FormControl, FormGroup } from '@angular/forms';
import { BookingService } from '../booking/booking.service';
import { Response } from 'express';
import { RESPONSE } from '@nguniversal/express-engine/tokens';

//<forWeek>
export enum Days {
  yesterday = -1,
  today = 0,
  tommorrow = 1,
  afterTommorrow = 2,
  after2Days = 3,
  after3Days = 4,
  after4Days = 5,
  after5Days = 6,
  after6Days = 7
}

export class Week {
  dayName: any;
  fullDate: any;
  month: any;
  year: any;
  date: any
  Times?: Time[]
}
export class Time { Time: any }
export class Slot { }

// </forWeek>

@Component({
  selector: 'app-doctor-profile',
  templateUrl: './doctor-profile.component.html',
  styleUrls: ['./doctor-profile.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})



export class DoctorProfileComponent implements OnInit {

  notAvailableText = this?.app?.languageCode == 'en' ? "Not available by the doctor" : "غير متوفرة لدى الطبيب";

  doctorDetails;
  classificationVisability: boolean = true

  medicalServices;

  textSectionTitle = null

  // <FOR Avaliable Timings>

  // forWeek
  Week: Week[] = [];
  todayDate;
  monthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  monthsAr = ["كانون الثاني", "شباط", "آذار", "نيسان", "أيار", "حزيران", "تموز", "آب", "أيلول", "تشرين الأول", "تشرين الثاني", "كانون الأول"];
  daysEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  daysAr = ["الاحد", "الاثنين", "الثلاثاء", "الاربعاء", "الخميس", "الجمعة", "السبت"];
  selected: string = "";
  currentLang = 'en';

  serviceId
  // isServiceSelected: Boolean = false
  // hasMoreThanOneService: Boolean = false

  rateDiv: Boolean = false


  // </FOR Avaliable Timings>

  constructor(
    private route: ActivatedRoute,
    private service: DoctorProfileService,
    public app: AppService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private toaster: ToastrService,
    private clipboard: Clipboard,
    private socialService: DoctorSocialService,
    private serviceBooking: BookingService,
    @Optional() @Inject(RESPONSE) private responseExpress: Response
  ) { }

  form: FormGroup;
  promoCode;

  ngOnInit(): void {
    this.form = new FormGroup({
      Now: new FormControl(false),
      Latitude: new FormControl(0),
      Longitude: new FormControl(0),
      Address: new FormControl(''),
      PaymentMethod: new FormControl(''),
      ServiceType: new FormControl(0),
      RelativeId: new FormControl(0),
      VisitDate: new FormControl(''),
      Comment: new FormControl(''),
      Symptoms: new FormControl(0),
      PromoCodeId: new FormControl(this?.promoCode ? this?.promoCode?.id : ''),
      Images: new FormControl(0),
      HcpId: new FormControl(),

      PromoCodeStringNotMapped: new FormControl(''),
    });
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
      this.getLastWeeksDate();
      if (this?.app?.getUserData()) {
        this.getRelatives();
      }
      this.slideConfig();
    }
    this.checkBeforeGetHcp();
  }

  get = (formControlName: string) => this.form.get(formControlName) as FormControl;

  slideConfig() {
    if (this?.app?.getUserLanguage() == 'ar') {
      this.slideConfigureForDoctor.rtl = true
    }
  }


  slideConfigureForDoctor = {
    dots: false,
    autoplay: false,
    infinite: false,
    variableWidth: false,
    draggable: false,
    rtl: false,
    arrows: true,
    slidesToShow: 3,
  };

  nameUrlToCompare;
  checkBeforeGetHcp() {
    const str = this.route.snapshot.paramMap.get('id')
    const firstPart = Number(str.substring(0, str.indexOf("_")));
    const secondPart = str.substring(str.indexOf('_') + 1);
    this.nameUrlToCompare = secondPart
    if (firstPart != 0) {
      this.getDoctorsDetails(firstPart)
    } else {
      if (/^\d+$/.test(str)) {
        let numberValue = parseInt(str, 10);
        this.getDoctorsDetails(numberValue)
      } else {
        console.log('Invalid ID in URL');
        this.router.navigate(['/' + this?.app?.languageCode + '/home']);
      }
    }

  }


  getDoctorsDetails(id) {
    this.service.getDoctorById(id).subscribe(
      res => {
        if (res.errorCode == 0) {
          let Lcode = this?.router?.url?.includes('/en/') ? 'en' : 'ar'
          if (isPlatformServer(this.platformId)) {
            if (this.nameUrlToCompare != this?.app?.routeToDoctorProfileReturningOnlyNameAndSpech(res?.data,Lcode)) {
              let nameAndSpechUpdated = this?.app?.routeToDoctorProfileReturningOnlyNameAndSpech(res?.data,Lcode)
              // `${doc?.id}_${j}${x}`
              const urlRedirectTo = `/${encodeURIComponent(Lcode)}/doctor-profile/${encodeURIComponent(res?.data?.id)}_${encodeURIComponent(nameAndSpechUpdated)}`;
              this.responseExpress.set('location', urlRedirectTo);
              this.responseExpress.setHeader('Content-Type', 'text/plain');
              this.responseExpress.statusCode = 301;
              return
            }
          }

          this.hcpUserId = res?.data?.userId
          if (isPlatformServer(this.platformId)) {
            if (res?.data?.isIndex == false) {
              this.app.updateIndexMeta();
            }
            this.getDoctorPostsSSR();
          }
          this.doctorDetails = res?.data
          if (isPlatformBrowser(this.platformId)) {
            if (res?.data?.medicalServices?.length > 0) {
              this.medicalServices = res?.data?.medicalServices
            }
            if (res?.data?.medicalServices?.length > 3) {
              this.doctorDetails.hasMoreThan3Services = true
            }
            if (res?.data?.companies?.length >= 5) {
              this.doctorDetails.hasMoreThan4Insurances = true
            }
            if (res?.data?.hcpDegrees?.length >= 5) {
              this.doctorDetails.hasMoreThan4hcpDegrees = true
            }
            this.getDoctorPosts();
            // if (this.medicalServices.length == 1) {
            // this.isServiceSelected = true;
            // this.Week = undefined
            // this.Slots = undefined
            // this.selected = undefined
            // this.serviceId = this.doctorDetails.medicalServices[0].id
            // this.getDaySlots();
            // } else if (this.medicalServices.length > 1) {
            // this.hasMoreThanOneService = true
            // }
            // HandleInitTimeSlots
            let initClassification
            if (res?.data?.hasClinicServices == true) {
              initClassification = 3
            } else if (res?.data?.hasVideoServices == true) {
              initClassification = 2
            } else if (res?.data?.hasVisitServies == true) {
              initClassification = 1
            }

            switch (initClassification) {
              case 1:
                this.switchOnClick('home', initClassification)
                break;
              case 2:
                this.switchOnClick('online', initClassification)
                break;
              case 3:
                this.switchOnClick('clinic', initClassification)
                break;
            }
            // HandleInitTimeSlots
          }
          // this?.app?.routeToDoctorProfile(res?.data)
          this.handleTitleAndMetas();
        }
      }
    )
  }

  selectedButton: "info" | "community" = "info"
  selectedButtonSub: "post" | "photos" | "vids" = "post"
  hcpUserId = null
  Posts: any[] = [];
  PostsForSSR: any[] = [];
  totalResult: number = 0
  pageNumber: any = 1
  mediaType = null

  async getDoctorPosts() {
    let request = new FormData();
    request.append("CreatorId", this?.hcpUserId);
    request.append("PageSize", "5");
    request.append("PageNumber", this?.pageNumber as string);
    if (this.mediaType != null) {
      request.append("MediaType", this?.mediaType as string);
    }
    await this.service.searchPosts(request).subscribe(
      async res => {
        if (res.errorCode == 0) {
          if (res.data.data.length) {

            const processedPosts = await Promise.all(res?.data?.data?.map(async item => {
              this?.app?.isMostlyEnglish(item?.postText) == true ? item.textDirection = "ltr" : item.textDirection = "rtl"
              if (item?.postMedia && item?.postMedia[0]?.mediaType === 3) {
                const transformedItem = await this.urlChangeInput(item);
                return transformedItem;
              }
              return item;
            }));
            this.Posts.push(...processedPosts);
            this.totalResult = res.data.totalRows;
          }
        }
      }
    )
  }

  getDoctorPostsSSR() {
    let request = {
      "pageSize": 6,
      "pageNumber": 1,
      "creatorId": this?.hcpUserId
    }
    this.service.searchPostsListSSR(request).subscribe(
      async res => {
        this.PostsForSSR = res?.data?.data
      }
    )
  }

  lastType = null;
  switchBtn(type) {
    if (type == this.lastType) { return }
    // reset
    this.pageNumber = 1
    this.totalResult = 0
    this.Posts.length = 0
    // this.scrollToTop();
    // reset
    switch (type) {
      case 'post': {
        this.lastType = type
        this.mediaType = null
        this.getDoctorPosts();
        break;
      }
      case 'photos': {
        this.lastType = type
        this.mediaType = 1
        this.getDoctorPosts();
        break;
      }
      case 'vids': {
        this.lastType = type
        this.mediaType = 2
        this.getDoctorPosts();
        break;
      }
    }
  }

  loadMorePosts() {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    this.pageNumber = this?.pageNumber + 1
    setTimeout(() => {
      this.getDoctorPosts();
    }, 100);
  }

  editPostPopUp(id, isMyPost) {
    if (this?.app?.IsSocialMediaManager) {
      const dialogRef = this.dialog.open(OptionsForModComponent, {
        width: '600px',
        data: id,
        panelClass: 'option-dialog',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res == "delete") {
          this.Posts = this.Posts.filter(item => item?.postId != id);
        } else if (res == "edit") {
          this.service.getPostById(id).subscribe(
            res => {
              if (res.errorCode == 0) {
                let obj = res?.data
                const index = this.Posts.findIndex(item => item?.postId == id);
                if (index != -1) {
                  this.Posts[index] = obj
                }
              }
            }
          )
        }
      });
    } else {
      if (isMyPost == true) {
        const dialogRef = this.dialog.open(FeedOptionsDialogComponent, {
          width: '600px',
          data: id,
          panelClass: 'option-dialog',
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(res => {
          if (res == "delete") {
            this.Posts = this.Posts.filter(item => item?.postId != id);
          } else if (res == "edit") {
            this.service.getPostById(id).subscribe(
              res => {
                if (res.errorCode == 0) {
                  let obj = res?.data
                  const index = this.Posts.findIndex(item => item?.postId == id);
                  if (index != -1) {
                    this.Posts[index] = obj
                  }
                }
              }
            )
          }
        });
      } else {
        const dialogRef = this.dialog.open(OthersFeedOptionsDialogComponent, {
          width: '600px',
          data: id,
          panelClass: 'option-dialog',
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(res => {
        });
      }
    }
  }

  postDetailsPopUp(id, index) {
    const dialogRef = this.dialog.open(PostDetailsPopUpComponent, {
      width: '100%',
      data: { id, index },
      panelClass: 'custom-modalBox',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == "delete") {
        this.Posts = this.Posts.filter(item => item?.postId !== id);
      } else if (res == "edit") {
        this.service.getPostById(id).subscribe(
          res => {
            if (res.errorCode == 0) {
              let obj = res?.data
              const index = this.Posts.findIndex(item => item?.postId == id);
              if (index != -1) {
                this.Posts[index] = obj
              }
              this.postDetailsPopUp(id, null)
            }
          }
        )
      } else if (res == "like") {
        this.service.getPostById(id).subscribe(
          res => {
            if (res.errorCode == 0) {
              let obj = res?.data
              const index = this.Posts.findIndex(item => item?.postId == id);
              if (index != -1) {
                this.Posts[index] = obj
              }
            }
          }
        )
      }
    });

  }

  likeDislikePost(postId, likeStatus, index) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (likeStatus == false) {
      this.service.likePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {
            this.Posts[index].likesCount = this.Posts[index].likesCount + 1
            this.Posts[index].iLikedPost = true
          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    } else if (likeStatus == true) {
      this.service.unlikePost(postId).subscribe(
        res => {
          if (res.errorCode == 0) {

            this.Posts[index].likesCount = this.Posts[index].likesCount - 1
            this.Posts[index].iLikedPost = false

          } else if (res.errorCode != 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.error("Something went wrong");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.error("حدث خطأ ما");
            }
          }
        }
      )
    }
  }

  chartPopUp(id, myPost) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (myPost == false) { return }
    // let id = this?.data
    const dialogRef = this.dialog.open(InsightsDialogComponent, {
      width: '700px',
      data: { id },
      panelClass: 'modalBoxScroll'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == true) {

      }
    });
  }

  likesPopUp(id, likeCount, type) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    if (likeCount == 0) { return }
    let req = {
      id: id,
      type: type,
    }
    const dialogRef = this.dialog.open(LikesListDialogComponent, {
      width: '470px',
      data: req
    });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  arrowPopUp(id) {
    let req = {
      "dynamicLinkInfo": {
        "domainUriPrefix": `https://ihospitalapp.page.link`,
        "link": `https://www.ihospitalapp.com/en/Tebgram/post/${id}`,
        "androidInfo": {
          "androidPackageName": "com.technzone.ihospital"
        },
        "iosInfo": {
          "iosBundleId": "com.technzone.ihospitalapp"
        }
      }
    }
    this.service.createDynamicLink(req).subscribe(
      res => {
        let link = res?.shortLink
        this.clipboard.copy(link);
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.info("Link Copied");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.info("تم نسخ الرابط");
        }
      }
    )
  }

  urlClicked(url) {
    window.open(url)
  }

  async urlChangeInput(item) {
    try {
      const itemData = item
      const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
      if (urlPattern.test(itemData?.postMedia[0]?.mediaFilePath)) {
        await this.socialService.getLinkPreviewData(itemData?.postMedia[0]?.mediaFilePath).subscribe(
          res => {
            let modifiedData = {
              mediaFilePath: itemData?.postMedia[0]?.mediaFilePath,
              mediaType: itemData?.postMedia[0]?.mediaType,
              mimeType: itemData?.postMedia[0]?.mimeType,
              urlTitle: res?.title,
              urlImage: res?.image,
              urlDescription: res?.description
            }
            itemData.postMedia[0] = modifiedData
          }
        )
      }
      return itemData
    } catch (error) {
      console.error('An error occurred:', error);
      return item
    }
  }

  handleTitleAndMetas() {
    let langServerSideCode = this?.router?.url?.includes('/ar/') ? 'ar' : 'en';
    let docName = this.splitStringToArAndEnForServer(this?.doctorDetails?.fullName)
    let docSpecialty = this.splitStringToArAndEnForServer(this?.doctorDetails?.speciality)
    if (langServerSideCode == 'ar') {
      this.app.updateTitleService(`احجز مع ${docName} اونلاين -  ${docSpecialty} | iHospital`);
      // this.app.updateMetaService(`${docName} - ${docSpecialty} | احجز الآن | iHospital`);

      this.textSectionTitle = `احجز مع ${docName} اونلاين - ${docSpecialty}`
    } else {
      this.app.updateTitleService(`Book with ${docName} Online | ${docSpecialty} | iHospital`);
      // this.app.updateMetaService(`${docName} - ${docSpecialty} | Book Now | iHospital`);

      this.textSectionTitle = `Book now with ${docName} - ${docSpecialty}`
    }

    // It Handles importing aboutDoc to meta tags under 155 chars(limit)
    let aboutMe = this.splitStringToArAndEnForAboutSSR(this?.doctorDetails?.about)
    if (aboutMe?.length <= 155) {
      this.app.updateMetaService(aboutMe);
    } else {
      let x = aboutMe?.slice(0, 155 - 3) + '...';
      this.app.updateMetaService(x);
    }
  }


  getMedicalServiceByClassification = () => {
    return
    this.router.navigate(['/' + this?.app?.languageCode + '/booking'], {
      queryParams: {
        'serviceId': this?.serviceId,
        'doctorId': this?.doctorDetails?.id,
        'hcpId': this?.doctorDetails?.userId,
      }
    });

    return
    // this.MedicalServices.value
    // this.dialog.open(ShowServicesDialogComponent, {
    //   data: {
    //     res: this.medicalServices,
    //     doctorId: this.doctorDetails
    //   },
    //   width: '600px',
    // })
  }





  splitStringToArAndEnForServer(sent: string): string {
    let langServerSideCode = this?.router?.url?.includes('/ar/') ? 'ar' : 'en';

    if (!sent || !sent.includes(' - ')) {
      return sent;
    }

    let x = sent?.split('-')
    let y = x[0]
    if (langServerSideCode == 'ar') {
      if (this.isProbablyArabic(y)) {
        return x[0]
      } else {
        return x[1]
      }
    } else if (langServerSideCode == 'en') {
      if (this.isProbablyArabic(y)) {
        return x[1]
      } else {
        return x[0]
      }
    }
    else {
      return sent
    }
  }


  splitStringToArAndEnForAboutSSR(sent: string): string {
    if (!sent) { return }
    let langServerSideCode = this?.router?.url?.includes('/ar/') ? 'ar' : 'en';
    if (sent.includes("-\t")) {
      let x = sent?.split("-\t")
      let y = x[0]
      if (langServerSideCode == 'ar') {
        if (this.isProbablyArabic(y)) {
          return x[0]
        } else {
          return x[1]
        }
      } else if (langServerSideCode == 'en') {
        if (this.isProbablyArabic(y)) {
          return x[1]
        } else {
          return x[0]
        }
      }
    } else if (sent.includes("\n")) {
      let x = sent?.split("\n\n")
      let y = x[0]
      if (langServerSideCode == 'ar') {
        if (this.isProbablyArabic(y)) {
          return x[0]
        } else {
          return x[1]
        }
      } else if (langServerSideCode == 'en') {
        if (this.isProbablyArabic(y)) {
          return x[1]
        } else {
          return x[0]
        }
      }
    } else {
      return sent
    }
  }


  isProbablyArabic(str: string): boolean {
    var Character
    for (var i = 0; i < str.length; i++) {
      let c = str.codePointAt(i);
      if (c >= 0x0600 && c <= 0x06E0)
        return true;
    }
    return false;
  }

  notLoggedInDialog() {
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '350px',
      data: {},
    });
    dialogRef.afterClosed().subscribe(res => {
    });
  }

  // FOR Avaliable Timings
  serviceDropDown(medicalserviceSelected) {
    return
    // this.isServiceSelected = true;
    // this.Week = undefined
    // this.Slots = undefined
    this.selected = undefined
    this.serviceId = medicalserviceSelected?.id
    // this.getLastWeeksDate();
    if (isPlatformBrowser(this.platformId)) {
      // this.getDaySlots();
    }
  }





  // For Week/Days/Slots

  // getDay = (day = 0): string => new Date(new Date().getFullYear(),
  //   new Date().getMonth(),
  //   new Date().getDate() + Number(day)).toISOString();

  getDay = (day): string => {
    const currentDate = new Date();
    const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + Number(day));
    const midnightDate = new Date(newDate.toISOString().split('T')[0]); // Extract the date part and create a new Date object
    return midnightDate.toISOString();
  };

  getDaySlots = (serviceId) => {
    const obj = {
      ServiceId: serviceId,
      From: this.getDay(+1),
      To: this.getDay(+90),
      IncludeSlots: true,
      HcpId: this?.doctorDetails?.userId
    }

    this.service.getDatSlot(obj).subscribe(res => {
      if (res.errorCode == 0) {
        let slotsB = this.deleteSlotsAfterNowTime(res.data)
        let slotsA = res.data
        slotsA[0].slots = slotsB
        const slots = slotsA;
        for (let index = 0; index < slots.length; index++) {
          this.Week[index].Times = slots[index]
        }
      }
    });
  }

  deleteSlotsAfterNowTime(data) {
    let dataS = data[0].slots
    let nowTime: Date = new Date();
    let dataZ = dataS.filter((item: any) => {
      return new Date(item.from).getTime() > nowTime.getTime()
    });
    return dataZ
  }

  // <For Week,Days,Slots>
  getLastWeeksDate = (): void => {
    const today = new Date();
    const next90Days = new Date(today.getTime() + (90 * 24 * 60 * 60 * 1000));

    this.todayDate = today.getDate();

    while (today.getTime() <= next90Days.getTime()) {
      const week: Week = {
        dayName: this.getDayName(today),
        fullDate: this.getFormattedDate(today),
        month: this.getMonthName(today),
        year: today.getFullYear(),
        date: today.getDate()
      };
      this.Week.push(week);
      today.setDate(today.getDate() + 1);
    }
  }

  getDayName(date: Date): string {
    let days;
    if (this.app?.getUserLanguage() == 'en') {
      days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    } else {
      days = ["الاحد", "الاثنين", "الثلاثاء", "الاربعاء", "الخميس", "الجمعة", "السبت"];
    }
    return days[date.getDay()];
  }

  getFormattedDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  getMonthName(date: Date): string {
    let months;
    if (this.app?.getUserLanguage() == 'en') {
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    } else {
      months = ["كانون الثاني", "شباط ", "آذار ", "نيسان ", "أيار ", "حزيران ", "تموز", "آب ", "أيلول ", "تشرين الأول ", "تشرين الثاني", "كانون الأول"];
    }
    return months[date.getMonth()];
  }
  // <For Week,Days,Slots/>




  // AddNameToUrl(HCPName, HCPSpecialty) {
  //   let resHCPName;
  //   let HCPNameSplit = HCPName?.split('-')
  //   let HCPNameSplitZero = HCPNameSplit[0]
  //   if (this.isProbablyArabic(HCPNameSplitZero)) {
  //     resHCPName = HCPNameSplit[1]
  //   } else {
  //     resHCPName = HCPNameSplit[0]
  //   }

  //   let resHCPSpecialty;
  //   let HCPSpecialtySplit = HCPSpecialty?.split('-')
  //   let HCPSpecialtyZero = HCPSpecialtySplit[0]
  //   if (this.isProbablyArabic(HCPSpecialtyZero)) {
  //     resHCPSpecialty = HCPSpecialtySplit[1]
  //   } else {
  //     resHCPSpecialty = HCPSpecialtySplit[0]
  //   }

  //   let x: String = resHCPName
  //   let y: String = resHCPSpecialty

  //   let m = `${x}/${y}`

  //   let j = m.replace(/ /g, '_');

  //   this.router.navigate([], {
  //     queryParams: {
  //       '_': j,
  //     },
  //     queryParamsHandling: 'merge',
  //     replaceUrl: true
  //   });
  // }


  // removeParamsFromUrl() {
  //   this.router.navigate([], {
  //     queryParams: {},
  //     queryParamsHandling: 'merge',
  //     replaceUrl: true
  //   });
  // }


  serviceSelected;
  selectedButtonAppointment: "home" | "clinic" | "online" = null
  switchOnClick(e, Classification) {
    if (this?.app?.isLoading == true || e == this.selectedButtonAppointment) { return }
    this.app.showLoading();
    let medicalService = this?.doctorDetails?.medicalServices?.find(x => x?.classification == Classification)
    this.serviceSelected = medicalService
    this.selected = undefined
    this.serviceId = medicalService?.id
    this.getDaySlots(medicalService?.id)
    this.get("ServiceType").setValue(medicalService?.id)
    this.paymentMethod();
    this.getSymptoms(medicalService?.id);
    switch (e) {
      case 'home':
        this.selectedButtonAppointment = e
        break;
      case 'clinic':
        this.selectedButtonAppointment = e
        break;
      case 'online':
        this.selectedButtonAppointment = e
        break;
    }
    this.app.dismissLoading();
  }

  isPaymentOnline: Boolean = false
  selectedTimeSlot
  @ViewChild('myButton') myButton;
  selectTimeSlotFun(e) {
    if (!this.app.getUserData()) {
      this.notLoggedInDialog();
      return
    }
    this.selectedTimeSlot = e
    console.warn(this.selectedTimeSlot)
    this.myButton.nativeElement.click();

  }

  checkValidityForm = (): Promise<Boolean> => {
    // Check Form Validity 
    if (this.form.invalid) {
      if (this?.app?.getUserLanguage() == 'en') {
        this.toaster.error("Please Fill out all required inputs.");
      } else if (this?.app?.getUserLanguage() == 'ar') {
        this.toaster.error("يرجى ملء جميع المدخلات المطلوبة.");
      }
      this.form.markAllAsTouched();
      return Promise.resolve(false);
    }

    // Check PromoCode
    // if (this.promoCode.errorCode == 404) {
    //   this.toaster.error("Invalid PromoCode")
    //   return Promise.resolve(false);
    // }

    return Promise.resolve(true) as Promise<Boolean>;
  }

  getRequestPayLoad() {
    let request = new FormData();

    request.append("Now", this.get("Now").value);
    request.append("Latitude", this.get("Latitude").value);
    request.append("Longitude", this.get("Longitude").value);
    request.append("Address", this.get("Address").value);
    request.append("PaymentMethod", this.get("PaymentMethod").value);
    request.append("ServiceType", this.get("ServiceType").value);
    if (this.get("RelativeId").value != 0) {
      request.append("RelativeId", this.get("RelativeId").value);
    }
    request.append("VisitDate", this.get("VisitDate").value);
    request.append("Comment", this.get("Comment").value);
    // request.append("To", this.get("To").value);
    this.get("Symptoms").value.length > 0 && this.get("Symptoms").value.map(item => request.append("Symptoms", item))
    request.append("PromoCodeId", this.get("PromoCodeId").value);
    this.get("Images").value.length > 0 && this.get("Images").value.map(item => request.append("Images", item))
    request.append("HcpId", this?.doctorDetails?.userId);

    return request;
  }

  submit = async (): Promise<void> => {
    this.app.showLoading();
    this?.get("VisitDate")?.setValue(this?.selectedTimeSlot?.from);
    if (this.get("PromoCodeStringNotMapped").value.length > 0) {
      const req = `${this?.get("PromoCodeString")?.value}?serviceId=${this.serviceId}`
      await this.checkValidityForm() && this.serviceBooking.getPromoCode(req).subscribe((res: any) => {
        if (res.errorCode == 0) {
          this.promoCode = res.data
          this.cd.detectChanges();
          this.postVisit();
        }
        if (res.errorCode == 404) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.error("Invalid PromoCode");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.error("الرمز الترويجي غير صالح");
          }
        }
      })
    }
    else if (this.get("PromoCodeStringNotMapped").value.length == 0) {
      this.postVisit();
    }
    this.app.dismissLoading();
  }

  private postVisit() {
    this.serviceBooking.postVisit(this.getRequestPayLoad()).subscribe(
      res => {
        if (res.errorCode == 0) {
          if (this.isPaymentOnline) {

            if (this?.serviceSelected?.price == 0) {
              this.bookToasterShoutOut();
              setTimeout(() => {
                this.router.navigate(['/' + this?.app?.languageCode + '/patients/visit'])
              }, 700);
              return
            }

            let visitId = res.data
            let request = new FormData();
            request.append("Amount", this?.serviceSelected?.price);
            request.append("Currency", "JOD");
            request.append("PaymentType", "2");
            request.append("VisitId", visitId);
            request.append("IsExtra", "false");

            this.serviceBooking.paymentGenerateCheckOutId(request).subscribe(
              res => {
                if (res.errorCode == 0) {
                  this.bookToasterShoutOut();
                  if (this?.serviceSelected?.price != 0) {
                    // return window.open(`https://www.ihospitalapp.com/IhospitalForm/payment_form.html?checkoutId=${res.data}?appoId=${visitId}`)
                    return (window.location.href = `https://www.ihospitalapp.com/IhospitalForm/payment_form.html?checkoutId=${res.data}?appoId=${visitId}`);
                  }
                }
              }
            )

          } else if (!this.isPaymentOnline) {
            this.bookToasterShoutOut();
            setTimeout(() => {
              this.router.navigate(['/' + this?.app?.languageCode + '/patients/visit'])
            }, 700);
          }
        } else if (res.errorCode != 0) {
          this.toaster.error(res.errorMessage)
        }

      }
    )
  }

  relatives;
  symptoms;
  private getSymptoms(serviceId) {
    this.serviceBooking.getSymptom(serviceId).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.symptoms = res.data
          this.cd.detectChanges()
        }
      }
    )
  }

  private getRelatives() {
    this.serviceBooking.getRelatives().subscribe(
      res => {
        if (res.errorCode == 0) {
          this.relatives = res.data
          this.cd.detectChanges()
        }
      }
    )
  }

  bookToasterShoutOut() {
    if (this?.app?.getUserLanguage() == 'en') {
      this.toaster.success("Booking successful");
    } else if (this?.app?.getUserLanguage() == 'ar') {
      this.toaster.success("تم الحجز بنجاح");
    }
    this.cd.detectChanges();
  }

  paymentMethod() {
    // classification 1 = home
    // classification 2 = online consult
    // classification 3 = clinic
    // classification 4 = shops

    // PaymentMethod 2 = visa/masterCard
    // PaymentMethod 1 = cash

    if (this?.serviceSelected?.classification == 2) {
      this?.get("PaymentMethod")?.setValue(2);
      this.isPaymentOnline = true
    } else if (this?.serviceSelected?.classification == 1 || this?.serviceSelected?.classification == 3) {
      this?.get("PaymentMethod")?.setValue(1);
      this.isPaymentOnline = false
    }
    this.cd.detectChanges();
  }


  imagesToAdd: any[] = [];
  imagesToPreview: any[] = [];
  readUrl(event: any) {
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        reader.onload = (event2: any) => {
          this.imagesToPreview.push({ image: event2.target.result, imageName: event.target.files[i].name });
          this.cd.detectChanges();
        };
        this.imagesToAdd.push(event.target.files[i]);
        this.cd.detectChanges();
        this.get("Images").setValue(this.imagesToAdd);
        reader.readAsDataURL(event.target.files[i]);
        this.cd.detectChanges();
      }
      this.cd.detectChanges();
    }
    this.cd.detectChanges();
  }

  removeFromImages(image) {
    this.imagesToPreview = this.imagesToPreview.filter(x => x.image != image.image);
    const img = this.imagesToAdd.find(x => x.name === image.imageName);
    this.imagesToAdd = this.imagesToAdd.filter(x => x.name !== image.imageName);
    this.get("Images").setValue(this.imagesToAdd);
    this.cd.detectChanges();
  }


}

